import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "cropper-box" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "cropper-box" }
const _hoisted_5 = { class: "d-flex justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-primary me-4",
  for: "uploads"
}, " Browse ", -1)
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vueCropper = _resolveComponent("vueCropper")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isCroppedMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "cropper-style show-mode",
              style: _normalizeStyle(`background-image: url('${_ctx.cropperOption.img}');`)
            }, [
              _createElementVNode("label", {
                class: "explain-box",
                onClick: _cache[0] || (_cache[0] = 
              () => {
                _ctx.isCroppedMode = true;
              }
            )
              }, "Click To Edit")
            ], 4)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_vueCropper, {
              class: "cropper-style",
              ref: "cropper",
              img: _ctx.cropperOption.img,
              "output-size": _ctx.cropperOption.size,
              "output-type": _ctx.cropperOption.outputType,
              info: true,
              full: _ctx.cropperOption.full,
              "can-move": _ctx.cropperOption.canMove,
              "can-move-box": _ctx.cropperOption.canMoveBox,
              "fixed-box": _ctx.cropperOption.fixedBox,
              original: _ctx.cropperOption.original,
              "auto-crop": _ctx.cropperOption.autoCrop,
              "auto-crop-width": _ctx.cropperOption.autoCropWidth,
              "auto-crop-height": _ctx.cropperOption.autoCropHeight,
              "center-box": _ctx.cropperOption.centerBox,
              high: _ctx.cropperOption.high,
              "max-img-size": _ctx.cropperOption.max,
              aspectRatio: _ctx.cropperOption.ratio,
              initialAspectRatio: _ctx.cropperOption.initRatio,
              onImgLoad: $setup.imgLoad,
              onCropMoving: _ctx.cropMoving
            }, null, 8, ["img", "output-size", "output-type", "full", "can-move", "can-move-box", "fixed-box", "original", "auto-crop", "auto-crop-width", "auto-crop-height", "center-box", "high", "max-img-size", "aspectRatio", "initialAspectRatio", "onImgLoad", "onCropMoving"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("input", {
              type: "file",
              id: "uploads",
              style: {"position":"absolute","clip":"rect(0 0 0 0)"},
              accept: "image/png, image/jpeg, image/gif, image/jpg",
              onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectImage($event)))
            }, null, 32),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.finishAndUploadToS3('base64'))),
                  class: "btn btn-success me-4",
                  disabled: _ctx.disableSubmit
                }, " Save ", 8, _hoisted_7))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[3] || (_cache[3] = 
            () => {
              _ctx.isCroppedMode = false;
            }
          ),
                  class: "btn btn-danger"
                }, " Cancel "))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}